<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      ref="crud"
      v-model="form"
      v-model:page="page"
      :permission="permissionObj"
      :before-open="beforeOpen"
      @row-del="rowDel"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
    >
      <template #menu-left>
        <el-button
          v-if="permissionObj.add && !recycleMode"
          type="primary"
          icon="el-icon-plus"
          @click="$refs.crud.rowAdd()"
          >{{ Lang.btn.addNew }}
        </el-button>
        <el-button
          type="danger"
          icon="el-icon-delete"
          v-if="permissionObj.delete && !recycleMode"
          plain
          @click="handleDelete"
          >{{ Lang.btn.delete }}
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-refresh"
          v-if="!recycleMode"
          @click="handleRecycle"
          >{{ Lang.btn.recycleStation }}
        </el-button>
        <el-button
          type="success"
          plain
          icon="el-icon-check"
          v-if="recycleMode"
          @click="handleRecyclePass"
          >{{ Lang.btn.recover }}
        </el-button>
        <el-button
          type="danger"
          plain
          icon="el-icon-close"
          v-if="recycleMode"
          @click="handleRecycleRemove"
          >{{ Lang.btn.delete }}
        </el-button>
        <el-button
          type="primary"
          plain
          icon="el-icon-refresh-left"
          v-if="recycleMode"
          @click="handleRecycleBack"
          >{{ Lang.btn.turnback }}
        </el-button>
        <el-tooltip
          class="item"
          effect="dark"
          :content="Lang.tips.configTenantContent"
          placement="top"
        >
          <el-button
            plain
            type="info"
            v-if="!recycleMode"
            icon="el-icon-setting"
            @click="handleSetting"
            >{{ Lang.btn.authConfig }}
          </el-button>
        </el-tooltip>
        <!-- <el-tooltip
          class="item"
          effect="dark"
          content="给租户配置独立数据源以实现数据库隔离"
          placement="top"
        >
          <el-button
            plain
            type="info"
            v-if="!recycleMode"
            icon="el-icon-coin"
            @click="handleDatasource"
            >数据源配置
          </el-button>
        </el-tooltip> -->
        <!-- <el-tooltip class="item" effect="dark" content="将菜单产品包与租户配置绑定" placement="top">
          <el-button
            plain
            type="info"
            v-if="!recycleMode"
            icon="el-icon-notebook"
            @click="handlePackage"
            >产品包配置
          </el-button>
        </el-tooltip> -->
        <!-- <el-tooltip
          class="item"
          effect="dark"
          content="将自定义的菜单集合定制为租户绑定的菜单产品包"
          placement="top"
        >
          <el-button
            plain
            type="info"
            v-if="!recycleMode"
            icon="el-icon-set-up"
            @click="handlePackageSetting"
            >产品包管理
          </el-button>
        </el-tooltip> -->
      </template>
      <!-- <template #menu="scope">
        <el-button
          v-if="!recycleMode"
          type="primary"
          icon="el-icon-coin"
          @click.stop="handleRowDatasource(scope.row)"
          >{{ Lang.btn.dataSource }}
        </el-button>
        <el-button
          v-if="!recycleMode"
          type="primary"
          icon="el-icon-notebook"
          @click.stop="handleRowPackage(scope.row)"
          >{{ Lang.btn.productPack }}
        </el-button>
      </template> -->
      <!-- 操作菜单按钮 -->
      <template #menu="scope">
        <div class="operation-btns">
          <CompIconButton :auth="permissionObj" type="view" @click="handleView(scope.row)" > </CompIconButton>
          <CompIconButton :auth="permissionObj" type="edit" @click="handleEdit(scope.row)" > </CompIconButton>
          <CompIconButton :auth="permissionObj" type="delete" :divider="false" @click="handleDel(scope.row)" > </CompIconButton>
        </div>
      </template>
      <template #accountNumber="{ row }">
        <el-tag>{{ row.accountNumber > 0 ? row.accountNumber : Lang.tips.unLimit }}</el-tag>
      </template>
      <template #expireTime="{ row }">
        <el-tag>{{ row.expireTime ? row.expireTime : Lang.tips.unLimit }}</el-tag>
      </template>
    </avue-crud>
    <el-dialog :title="Lang.tips.tenantAuthConfig" append-to-body v-model="box" width="450px">
      <avue-form :option="settingOption" v-model="settingForm" @submit="handleSubmit" />
    </el-dialog>
    <el-dialog :title="Lang.tips.tenantDataSourceConfig" append-to-body v-model="datasourceBox" width="450px">
      <avue-form
        :option="datasourceOption"
        v-model="datasourceForm"
        @submit="handleDatasourceSubmit"
      />
    </el-dialog>
    <el-dialog :title="Lang.tips.tenantProductPackConfig" append-to-body v-model="packageBox" width="450px">
      <avue-form
        ref="formPackage"
        :option="packageOption"
        v-model="packageForm"
        @submit="handlePackageSubmit"
      />
    </el-dialog>
    <el-drawer
      :title="Lang.tips.tenantProductPackManage"
      append-to-body
      v-model="packageSettingBox"
      direction="rtl"
      size="50%"
    >
      <tenant-package></tenant-package>
    </el-drawer>
  </basic-container>
</template>

<script>
import {
  getList,
  getDetail,
  update,
  add,
  setting,
  datasource,
  packageInfo,
  packageSetting,
  recycle,
  pass,
  remove,
} from '@/api/system/tenant';
import { getDetail as packageDetail } from '@/api/system/tenantpackage';
import { mapGetters } from 'vuex';
import { getMenuTree } from '@/api/system/menu';
import { validatenull } from '@/utils/validate';
import { validateWord } from '@/utils/validator';

export default {
  data() {
    return {
      form: {},
      selectionList: [],
      query: {},
      loading: true,
      box: false,
      datasourceBox: false,
      packageBox: false,
      packageSettingBox: false,
      recycleMode: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {
        height: 'auto',
        calcHeight: 104,
        tip: false,
        searchShow: true,
        searchSpan: 4,
        searchMenuSpan: 4,
        searchMenuPosition: 'right',
        searchLabelWidth: 'auto',
        searchGutter: 20,
        gutter: 12,
        border: true,
        index: true,
        indexLabel: this.Lang.table.serialNumber,
        indexWidth: '100%',
        selection: true,
        viewBtn: true,
        menuWidth: 116, // 操作列宽
        addBtn: false, // 添加
        viewBtn: false, // 查看
        editBtn: false, // 编辑
        delBtn: false, // 删除
        menuType: 'button',
        menuTitle: this.Lang.label.operation,
        menuHeaderAlign: 'right', // 操作按钮样式
        dialogWidth: 900,
        dialogClickModal: false,
        dialogType: 'drawer',
        labelWidth: 'auto',
        searchLabelPosition: 'left',
        labelPosition: 'top',
        dialogCustomClass: 'dialog-custom-class-sort',
        column: [
          {
            label: this.$t('theader.tenantId'),
            prop: 'tenantId',
            width: 100,
            search: true,
            addDisplay: false,
            editDisplay: false,
            span: 24,
            rules: [
              {
                required: true,
                message: this.Lang.tips.inputTenantId,
                trigger: 'blur',
              },
              {
                message: this.Lang.tips.plzInputEnCharater,
                trigger: 'blur',
                validator: validateWord,
              },
            ],
          },
          {
            label: this.$t('theader.tenantName'),
            prop: 'tenantName',
            search: true,
            width: 180,
            span: 24,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputParamName,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.$t('theader.contact'),
            prop: 'linkman',
            width: 100,
            search: true,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputContactMan,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.$t('theader.contactNumber'),
            prop: 'contactNumber',
            width: 150,
          },
          {
            label: this.$t('theader.correspondenceAddress'),
            prop: 'address',
            span: 24,
            minRows: 2,
            type: 'textarea',
            hide: true,
          },
          {
            label: this.$t('theader.accountLimit'),
            prop: 'accountNumber',
            width: 90,
            slot: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: this.$t('theader.expirationTime'),
            prop: 'expireTime',
            type: 'date',
            format: 'YYYY-MM-DD HH:mm:ss',
            valueFormat: 'YYYY-MM-DD HH:mm:ss',
            width: 180,
            slot: true,
            addDisplay: true,
            editDisplay: true,
          },
          {
            label: this.$t('theader.bindDomainName'),
            prop: 'domainUrl',
            span: 24,
          },
          {
            label: this.Lang.label.systemBackground,
            prop: 'backgroundUrl',
            type: 'upload',
            listType: 'picture-img',
            dataType: 'string',
            action: '/blade-resource/oss/endpoint/put-file',
            propsHttp: {
              res: 'data',
              url: 'link',
            },
            hide: true,
            span: 24,
          },
        ],
      },
      data: [],
      settingForm: {},
      settingOption: {
        column: [
          {
            label: this.Lang.label.accountAmount,
            prop: 'accountNumber',
            type: 'number',
            span: 24,
          },
          {
            label: this.Lang.label.expireTime,
            prop: 'expireTime',
            type: 'date',
            format: 'YYYY-MM-DD HH:mm:ss',
            valueFormat: 'YYYY-MM-DD HH:mm:ss',
            span: 24,
          },
        ],
      },
      datasourceForm: {},
      datasourceOption: {
        column: [
          // {
          //   label: '数据源',
          //   prop: 'datasourceId',
          //   search: true,
          //   span: 24,
          //   type: 'select',
          //   dicUrl: '/blade-develop/datasource/select',
          //   props: {
          //     label: 'name',
          //     value: 'id',
          //   },
          //   rules: [
          //     {
          //       required: true,
          //       message: '请选择数据源',
          //       trigger: 'blur',
          //     },
          //   ],
          // },
        ],
      },
      packageForm: {},
      packageOption: {
        column: [
          // {
          //   label: '产品包',
          //   prop: 'packageId',
          //   search: true,
          //   span: 24,
          //   type: 'select',
          //   dicUrl: '/blade-system/tenant-package/select',
          //   props: {
          //     label: 'packageName',
          //     value: 'id',
          //   },
          // },
          {
            label: this.Lang.label.menuPreview,
            prop: 'menuId',
            span: 24,
            type: 'tree',
            dicData: [],
            hide: true,
            multiple: true,
            props: {
              label: 'title',
            },
          },
        ],
      },
    };
  },
  watch: {
    'packageForm.packageId'() {
      if (!validatenull(this.packageForm.packageId)) {
        packageDetail(this.packageForm.packageId).then(res => {
          this.packageForm.menuId = res.data.data.menuId;
          this.initData();
        });
      }
    },
  },
  computed: {
    ...mapGetters(['menuItem', 'permission']),
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
        }
      }))
      return obj
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
    tenantId() {
      return this.selectionList[0].tenantId;
    },
  },
  methods: {
    // 自定义查看
    handleView(row) {
      this.$refs.crud.rowView(row);
    },
    // 自定义编辑
    handleEdit(row) {
      this.$refs.crud.rowEdit(row);
    },
    // 自定义删除
    handleDel(row) {
      this.$refs.crud.rowDel(row);
    },
    initData() {
      getMenuTree().then(res => {
        const column = this.findObject(this.packageOption.column, 'menuId');
        column.dicData = res.data.data;
      });
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm(this.Lang.tips.ifConfirmDeleteTenant, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return recycle(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    beforeOpen(done, type) {
      if (['view'].includes(type)) {
        getDetail(this.form.id).then(res => {
          const data = res.data.data;
          if (!(data.accountNumber > 0)) {
            data.accountNumber = this.Lang.tips.unLimit;
          }
          if (!data.expireTime) {
            data.expireTime = this.Lang.tips.unLimit;
          }
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$confirm(this.Lang.tips.ifConfirmDeleteTenant, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return recycle(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.crud.toggleSelection();
        });
    },
    handleRecycle() {
      this.recycleMode = true;
      this.$refs.crud.option.editBtn = false;
      this.$refs.crud.option.delBtn = false;
      this.onLoad(this.page, this.query);
    },
    handleRecyclePass() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$confirm(this.Lang.tips.ifConfirmRecoverTenant, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return pass(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.crud.toggleSelection();
        });
    },
    handleRecycleRemove() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$confirm(this.Lang.tips.ifConfirmDeleteTenant, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.crud.toggleSelection();
        });
    },
    handleRecycleBack() {
      this.recycleMode = false;
      this.$refs.crud.option.editBtn = true;
      this.$refs.crud.option.delBtn = true;
      this.onLoad(this.page, this.query);
    },
    handleSetting() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      if (this.selectionList.length === 1) {
        getDetail(this.selectionList[0].id).then(res => {
          const data = res.data.data;
          this.settingForm.accountNumber = data.accountNumber;
          this.settingForm.expireTime = data.expireTime;
        });
      } else {
        this.settingForm.accountNumber = -1;
        this.settingForm.expireTime = '';
      }
      this.box = true;
    },
    handleRowDatasource(row) {
      getDetail(row.id).then(res => {
        const data = res.data.data;
        this.datasourceForm.tenantId = row.tenantId;
        this.datasourceForm.datasourceId = data.datasourceId;
      });
      this.datasourceBox = true;
    },
    handleDatasource() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      if (this.selectionList.length !== 1) {
        this.$message.warning(this.Lang.tips.onlyCanSelectOne);
        return;
      }
      getDetail(this.selectionList[0].id).then(res => {
        const data = res.data.data;
        this.datasourceForm.tenantId = this.selectionList[0].tenantId;
        this.datasourceForm.datasourceId = data.datasourceId;
      });
      this.datasourceBox = true;
    },
    handleRowPackage(row) {
      packageInfo(row.id).then(res => {
        const data = res.data.data;
        this.packageForm.tenantId = row.tenantId;
        this.packageForm.packageId = data.id;
        this.packageForm.menuId = data.menuId;
      });
      this.packageBox = true;
      //更新字典远程数据
      setTimeout(() => {
        const form = this.$refs.formPackage;
        form.updateDic('packageId');
      }, 10);
    },
    handlePackage() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      if (this.selectionList.length !== 1) {
        this.$message.warning(this.Lang.tips.onlyCanSelectOne);
        return;
      }
      if (this.selectionList.length === 1) {
        packageInfo(this.selectionList[0].id).then(res => {
          const data = res.data.data;
          this.packageForm.tenantId = this.selectionList[0].tenantId;
          this.packageForm.packageId = data.id;
          this.packageForm.menuId = data.menuId;
        });
      } else {
        this.packageForm.menuId = '';
      }
      this.packageBox = true;
      //更新字典远程数据
      setTimeout(() => {
        const form = this.$refs.formPackage;
        form.updateDic('packageId');
      }, 10);
    },
    handlePackageSetting() {
      this.packageSettingBox = true;
    },
    handleSubmit(form, done, loading) {
      setting(this.ids, form).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.configSucceed,
          });
          done();
          this.box = false;
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    handleDatasourceSubmit(form, done, loading) {
      datasource(form.tenantId, form.datasourceId).then(
        () => {
          this.$message({
            type: 'success',
            message: this.Lang.tips.configSucceed,
          });
          done();
          this.datasourceBox = false;
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    handlePackageSubmit(form, done, loading) {
      packageSetting(form.tenantId, form.packageId).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.configSucceed,
          });
          done();
          this.packageBox = false;
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      getList(
        page.currentPage,
        page.pageSize,
        Object.assign(params, this.query, {
          status_equal: this.recycleMode ? -1 : 1,
        })
      ).then(res => {
        const data = res.data.data;
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
  },
};
</script>

<style></style>
